module.exports = __webpack_public_path__ + "site-4.jpg?f8f127a074f6fafe9f974d0869ea1d87";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-4.jpg
 ** module id = 147
 ** module chunks = 0
 **/